import constants from "@/constants.js";

export function isAuthenticated() {
    return Boolean(getJwt());
}

export function isAdmin() {
    return Boolean(getBackofficeRole());
}

/**
 * Store JWT in localStorage.
 * @param {string} jwt
 */
export function authenticate(jwt) {
    window.localStorage.setItem(constants.STORAGE_KEY_JWT, jwt);
}

export function getJwt() {
    return window.localStorage.getItem(constants.STORAGE_KEY_JWT);
}

/**
 * @returns {string[]} - e.g. ["ROLE_USER", "ROLE_ADMIN"]
 */
export function getUsersRoles() {
    const jwt = getJwt();
    if(!jwt) return [];
    const [, body] = jwt.split(".");
    const { roles } = JSON.parse(atob(body));
    return roles.replace("[","").replace("]","").split(",");
}

export function getBackofficeRole() {
    if(getUsersRoles().includes(constants.SUPER_ADMIN_ROLE)) return "super-admin";
    else if(getUsersRoles().includes(constants.ADMIN_ROLE)) return "admin";
    else if(getUsersRoles().includes(constants.MANAGER_ROLE)) return "manager";
    else if(getUsersRoles().includes(constants.COMMUNITY_MANAGER_ROLE)) return "community-manager";
    else return false;
}

export function logout() {
    window.localStorage.removeItem(constants.STORAGE_KEY_JWT);
    window.location.reload();
}
